import { useEffect, useRef } from 'react';

export function useLoadingState(isFetching: boolean, hasData: boolean) {
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (hasData || !isFetching) {
      hasLoadedRef.current = true;
    }
  }, [isFetching, hasData]);

  return {
    isInitialLoading: isFetching && !hasLoadedRef.current,
    isRefetching: isFetching && hasLoadedRef.current,
  };
}
